var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('quill-editor',{ref:"myQuillEditor",style:(_vm.styleConfig),attrs:{"options":_vm.config},on:{"change":function () {
        _vm.clearError();
        _vm.change();
      },"blur":_vm.formatText},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"localValue"}}),_c('upload-file',{ref:"myVueDropzone",attrs:{"options":_vm.uploadOptions,"preventDuplicateName":true,"showDefault":false,"maxFiles":100},on:{"changed":function (files, isRemove) {
        _vm.changeFile(files, isRemove);
        _vm.changeInput('quill_image');
      },"uploading":function (status) {
        _vm.uploading = status;
      },"pushError":_vm.pushError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }